
import { User } from '@/types/User'


export default {
    namespaced: true,
    state: {
        User: <User>{
            consent:false
        }

    },
    // getters: {
    //     // [types.MUTATION]: state => state.value,
    //     getLogValue: state => state.LogValue,
    // },
    // mutations: {
    //     // [types.MUTATION](state, value) {
    //     //     state.value = value;
    //     // },
    //     SetLogvalue(state, payload) {
    //         state.LogValue = { ...state.LogValue, payload};
    //     },

    // },
    actions: {}
}